import React, { createContext, useContext, useState, useCallback } from "react"

const NotificationActionContext = createContext(null)

export const NotificationActionProvider = ({ children }) => {
  const [pendingAction, setPendingAction] = useState(null)

  const triggerAction = useCallback((action) => {
    setPendingAction(action)
  }, [])

  const clearAction = useCallback(() => {
    setPendingAction(null)
  }, [])

  return (
    <NotificationActionContext.Provider value={{ pendingAction, triggerAction, clearAction }}>
      {children}
    </NotificationActionContext.Provider>
  )
}

export const useNotificationAction = () => {
  const context = useContext(NotificationActionContext)
  if (!context) {
    throw new Error("useNotificationAction must be used within NotificationActionProvider")
  }
  return context
}
